<template>
  <div class="index" v-cloak>

    <div class="slider-banner banner">
      <swiper :options="swiperOption" v-if="banner.length > 0">
        <swiper-slide v-for="(item, index) in banner" :key="index">
          <img class="swiper-img" :src="item.pic" />
        </swiper-slide>
        <div class="swiper-pagination paginationBanner" slot="pagination"></div>
      </swiper>
    </div>

    <div class="opt-list">
	  <div  v-for="(item, index) in cate_list"  class="opt-sty">
		  <div class="opt-item"  @click="goPage('/rights')" v-if="item.title=='妇儿维权'">
		    <img class="opt-img" :src="item.image" alt="">
		    <div class="opt-title">妇儿维权</div>
		  </div>
		  <div class="opt-item"  @click="goCate(item.id, item.is_area)" v-else>
		    <img class="opt-img" :src="item.image" alt="">
		    <div class="opt-title">{{item.title}}</div>
		  </div>
	  </div>
    </div>
    <!-- 推荐活动 -->

    <div class="rec-list">
      <div class="rec-title">推荐活动</div>
      <div class="rec-item" v-for="item in articleList" @click="goDetail(item.id)">
        <img class="rec-img" :src="item.image_input" alt="">
        <div style="padding-bottom: 20px;">{{item.title}}</div>
      </div>
    </div>
    <!-- <div class="nav-list">
      <div class="nav-item" @click="goCate(item.id, item.is_area)" v-for="(item, index) in cate_list">
        <img :src="item.image" alt="">
      </div>
    </div> -->

    <div class="index-botom" style="height:1.5rem"></div>
    <Footer></Footer>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import GoodList from "@components/GoodList";
import PromotionGood from "@components/PromotionGood";
import CouponWindow from "@components/CouponWindow";
import { getHomeData, getShare, follow, getFulianCate,getIsRecommend } from "@api/public";
import Footer from "@components/NewFooter";
const HAS_COUPON_WINDOW = "has_coupon_window";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
const MAPKEY = "mapKey";
let vm = null;
export default {
  name: "Index",
  components: {
    swiper,
    swiperSlide,
    GoodList,
    PromotionGood,
    CouponWindow,
    Footer
  },
  props: {},
  data: function () {
    return {

      banner: [],//轮播list

      swiperOption: {
        pagination: {
          el: ".paginationBanner",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
        on: {
          tap: function () {
            const realIndex = this.realIndex;
            vm.goUrl(realIndex);
          }
        }
      },//swiper设置

      cate_list: [],//分类列表
      articleList:[]
    };
  },
  created() {
    vm = this;
  },
  mounted: function () {
    // this.getFollow();
    let that = this;
    getHomeData().then(res => {

      that.$set(that, "banner", res.data.banner);
      that.getIsRecommend()

    });
    that.getFulianCate();
  },
  methods: {
    // 获取活动招募
    getIsRecommend(){
      let param = {
        page:1,
        limit:5
      }
      getIsRecommend(param).then(res => {
        this.articleList = res.data.list;
      });
    },
    getFulianCate: function () {
      let that = this;
      getFulianCate(0).then(res => {
        that.$set(that, "cate_list", res.data);
      })
    },
    goCate: function (id, is_area) {
      if (is_area) {
        this.$router.push({ path: "/area/news/list", query: { pid: id } });
      } else {
        this.$router.push({ path: "/normal/news/list", query: { pid: id } });
      }
    },
    goPage(url){
      this.$router.push({path:url});
    },
	goDetail: function (id) {
	  this.$router.push({ path: "/news_detail/" + id });
	},
  }
};
</script>
<style scoped>
[v-cloak] {
  display: none;
}
.swiper-img{
  object-fit: cover;
}
.index {
  background-color: #fceeef;
  min-height: 100vh;
}

.index .follow {
  z-index: 100000;
}

.keep {
  text-align: center;
}

.nav-list {
  display: flex;
  justify-content: space-between;
  /* align-items: center; */
  flex-wrap: wrap;
}

.nav-item {
  width: 50%;
}

.nav-item img {
  width: 100%;
  vertical-align: bottom;
}
</style>
<style lang="scss" scoped>

.opt-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  // justify-items: center;
  padding: .2rem;
  grid-gap: .20rem;
  // background-color: #fff;
  .opt-sty{
	  background-color: #fff;
	  padding: .30rem;
	  border-radius: 10px;
  }
  .opt-item{
    display: flex;
    // flex-direction: column;
	 justify-content: center;
    align-items: center;
	width: 100%;
    .opt-title{
      font-size: .23rem;
    }
  }
  .opt-img{
    width: .84rem;
    height: .84rem;
    border-radius: 50%;
    // background-size: 100%;
    object-fit: contain;
  }
}
.rec-list{
  // margin-top: .3rem;
  padding: 0 .3rem;
  background-color: #fceeef;
  .rec-title{
    line-height: 1.05rem;
    position: relative;
    font-size: .33rem;
    font-weight: bold;
    padding-left: .22rem;
    &::before{
      content: '';
      display: block;
      width: .07rem;
      height: .35rem;
      background-color: #ED546A;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translate(0,-50%);
      border-radius: .07rem;
    }
  }
  .rec-item{
    &~.rec-item{
      margin-top: .5rem;
    }
    .rec-img{
      width: 6.75rem;
      height: 3.2rem;
      font-size: .28rem;
      border-radius: .2rem;
      object-fit: cover;
    }
  }
}
</style>
